<template>
  <div>
    <!-- 若配置了多个课件 -->
    <div v-if="courseware.list.length > 0">
      <van-field
        v-model="courseware.selectedName"
        is-link
        label-width="40"
        readonly
        name="picker"
        label="课件"
        placeholder="点击选择课件"
        @click="showPicker = true"
      />
      <van-popup v-model:show="showPicker" position="bottom">
        <van-picker
          :columns="coursewareNames"
          @confirm="confirmCourseware"
          @cancel="showPicker = false"
        />
      </van-popup>
    </div>
    <div>
      <iframe :src="pdf_path + 'web/viewer.html?file=' + encodeURIComponent(courseware.selected)" height="500" width="100%" frameborder="0" style="display:block;"></iframe>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      courseware_list: Array
    },
    data() {
      return {
        showPicker: false,
        coursewareNames: [],
        url: '',
        courseware: {
          selectedName: '',
          selected: '',
          list: this.courseware_list,
        },
        pdf_path : process.env.NODE_ENV === 'production' ? `${process.env.BASE_URL}pdfjs/` : '/pdfjs/',
      }
    },
    mounted() {
      this.courseware.selectedName = this.courseware_list[0].name
      this.courseware.selected = this.courseware_list[0].ware_url
      let Base64 = require('js-base64').Base64
      this.url = this.pdf_path + 'web/viewer.html?file=' + this.courseware.selected

      for(let item of this.courseware.list) {
        this.coursewareNames.push(item.name);
      }
    },
    methods: {
      confirmCourseware(value, index) {
        this.courseware.selectedName = value;
        this.showPicker = false;
        this.courseware.selected = this.courseware.list[index].ware_url;
      }
    },
    watch: {
      courseware_list (val) {
        this.courseware.list = val
        this.courseware.selected = val[0].ware_url
        this.courseware.selectedName = val[0].name
        this.url = this.pdf_path + 'web/viewer.html?file=' + this.courseware.selected
        this.coursewareNames = new Array()
        for(let item of this.courseware.list) {
          this.coursewareNames.push(item.name);
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .form_wrap {
    padding:10px 15px;
    border-bottom: 1px solid #E4E7ED;
    .el-form-item {
      margin:0;
    }
  }
  .iframe_wrap {
    position:absolute;
    top:61px;
    left:0;
    right:0;
    bottom:0;
  }
</style>
